import decodeJwt from 'jwt-decode';
import Cookies from 'universal-cookie';

// TO-DO improve isAuthenticated method
export const isAuthenticated = () => {
  const cookies = new Cookies();
  let token = cookies.get('token');
  if (token) {
    return true;
  }
    return false;
};


/**
 * Login to backend and store JSON web token on success
 *
 * @param email
 * @param password
 * @returns JSON data containing access token on success
 * @throws Error on http errors or failed attempts
 */
export const login = async (email: string, password: string) => {

    if (!(email.length > 0) || !(password.length > 0)) {
        throw new Error('Email or password was not provided');
    }

    const formData = new FormData();
    formData.append('username', email);
    formData.append('password', password);

    const request = new Request('/api/token', {
        method: 'POST',
        body: formData,
    });

    const response = await fetch(request);

    if (response.status === 500) {
        throw new Error('Internal server error fronend');
    }

    const data = await response.json();

    if (response.status > 400 && response.status < 500) {
        if (data.detail) {
            throw data.detail;
        }
        throw data;
    }

    if ('access_token' in data) {
        const decodedToken: any = decodeJwt(data['access_token']);
        const cookies = new Cookies();
        cookies.set('token', 'Bearer ' + data.access_token, { domain: 'lb.ava.me', sameSite: 'lax' });
        cookies.set('username', decodedToken.sub, { domain: 'lb.ava.me', sameSite: 'lax' });
        localStorage.setItem('token', data['access_token']);
        localStorage.setItem('username', data['username']);
    }

    return data;
};
